const binding = { modules: {}, dataActions: {} };

    (binding.modules['starter-extended'] = {
        c: () => require('@msdyn365-commerce-modules/starter-theme-pack/dist/lib/modules/starter/starter'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox'],
        iNM: true,
        ns: '__local__',
        n: 'starter-extended',
        p: '__local__',
        
        pdp: 'node_modules/@msdyn365-commerce-modules/starter-theme-pack/dist/lib/modules/starter/starter.definition.json',
        
        themeSettings: 'starter-extended.theme.settings.json',
        md: 'src/themes/starter-extended'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };